import { Observable } from 'rxjs/Observable';

export const isObservable = (obj: object): obj is Observable<unknown> => obj instanceof Observable;
